import { Controller } from "@hotwired/stimulus"

// Entrata a comparsa (framer-motion whileInView di Landing.js): l'elemento con .reveal (o .reveal-scale,
// .reveal-banner) diventa visibile al primo ingresso nel viewport (rootMargin -80px) e non si osserva più.
// data-reveal-index-value=i ritarda di i*80ms; data-reveal-immediate = sopra la piega, subito.
// Con prefers-reduced-motion il CSS li mostra subito.
export default class extends Controller {
  static values = { index: { type: Number, default: 0 } }

  connect() {
    this.element.style.setProperty("--i", this.indexValue)
    const subito = this.element.hasAttribute("data-reveal-immediate")
    const ridotto = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
    if (subito || ridotto || typeof IntersectionObserver === "undefined") {
      this.mostra()
      return
    }
    this.observer = new IntersectionObserver((voci) => {
      if (voci.some((v) => v.isIntersecting)) this.mostra()
    }, { rootMargin: "-80px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  mostra() {
    this.element.classList.add("is-visible")
    this.observer?.disconnect()
    this.observer = null
  }
}
